import React from 'react';
import {
  ClockConfig,
  CustomHomepageGrid,
  HeaderWorldClock,
  HomePageCompanyLogo,
  HomePageRecentlyVisited, HomePageStarredEntities,
  HomePageTopVisited, WelcomeTitle,
} from '@backstage/plugin-home';
import { Content, Header, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import LogoFull from '../Root/LogoFull'
import { makeStyles } from '@material-ui/core';

const clockConfigs: ClockConfig[] = [
  {
    label: 'Chicago, IL',
    timeZone: 'America/Chicago',
  },
  {
    label: 'New York City, NY',
    timeZone: 'America/New_York',
  },
];

const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

const defaultConfig = [
  {
    component: 'CompanyLogo',
    x: 0,
    y: 0,
    width: 12,
    height: 1,
  },
  {
    component: 'HomePageSearchBar',
    x: 0,
    y: 1,
    width: 12,
    height: 2,
  },
  {
    component: 'HomePageTopVisited',
    x: 0,
    y: 2,
    width: 6,
    height: 4,
  },
  {
    component: 'HomePageRecentlyVisited',
    x: 6,
    y: 2,
    width: 6,
    height: 4,
  },
  {
    component: 'HomePageStarredEntities',
    x: 0,
    y: 3,
    width: 12,
    height: 3,
  },
];

export const useLogoStyles = makeStyles(() => ({
  container: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100px'
  },
  svg: {
    width: 'auto',
    height: 100,
  },
  path: {
    fill: '#7df3e1',
  },
}));

export const CustomHomePage = () => {
  const { container } = useLogoStyles();

  return (
    <Page themeId="home">
      <Header title={<WelcomeTitle language={['English']} />} pageTitleOverride="Home">
        <HeaderWorldClock
          clockConfigs={clockConfigs}
          customTimeFormat={timeFormat}
        />
      </Header>
      <Content>
        <CustomHomepageGrid config={defaultConfig}>
          <HomePageSearchBar />
          <HomePageStarredEntities />
          <HomePageCompanyLogo
            className={container}
            logo={<LogoFull />} />
          <HomePageTopVisited />
          <HomePageRecentlyVisited />
          <HomePageStarredEntities />
        </CustomHomepageGrid>
      </Content>
    </Page>
  );
}
